const defaultMessage = 'Fields don`t match.'

export const SameValueValidator =
    (targetValue: string, message = defaultMessage) =>
    (value: string) => {
        return value && value == targetValue ? undefined : message
    }
